import { cliente } from './api'
import { obtenerTokenStorage } from './sessionStorage'

export default {
  EnviarOtp(request) {
    const config = {
      params: request,
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    }
    return cliente.get('/persona/otp', config)
  },
  ReenviarOtp(request) {
    const config = {
      params: request,
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    }
    return cliente.get('/persona/otp', config)
  },
  ValidaOtp(request) {
    const config = {
      params: request,
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    }
    return cliente.post('/persona/valida_otp', {}, config)
  },
}
